import { ReplyType } from '@tencent/dz-bricks-web';
import { ReportModuleParams } from '@tencent/dz-report';
import { InputType, MessageSourceFrom } from '../const';


export const getMessageSource = (
  message: string,
  inputMessageSource: ReportModuleParams<{ reply_type: string; reply_content: string }>,
) => {
  const msgSource = {
    input_type: InputType.active,
    msg_source_from: MessageSourceFrom.default,
  };

  if (!inputMessageSource?.payload) {
    return msgSource;
  }

  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    payload: { reply_content, reply_type },
  } = inputMessageSource;

  if (reply_content !== '') {
    if (reply_content === message) {
      msgSource.input_type = InputType.unActive;
    }
    switch (reply_type) {
      case ReplyType.guess:
        msgSource.msg_source_from = MessageSourceFrom.guess_question;
        break;
      case ReplyType.consult:
        msgSource.msg_source_from = MessageSourceFrom.consult_btn;
        break;
      case ReplyType.retain:
        msgSource.msg_source_from = MessageSourceFrom.retain_popup;
        break;
      case ReplyType.reply:
        msgSource.msg_source_from = MessageSourceFrom.quick_reply;
        msgSource.input_type = InputType.active;
        break;
    }
  }
  return msgSource;
};
